// NewComponent.jsx
import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom'; // Assuming you are using React Router for navigation
import './NewComponent.css';
import bgimg from './bgimage2.png';

const NewComponent = ({ title, content, linkTo }) => {
    return (
    
            <Card className="new-card" style={{backgroundColor:'darkslategrey', color:'white'}}>
                <img src={bgimg} alt=''/>
                <CardContent className="cardContent">
                    <Typography variant="h3" style={{color:'goldenrod',fontFamily:'Cinzel Decorative'}} gutterBottom>
                        {title}
                    </Typography>
                    <Typography variant="h5" paragraph style={{fontFamily:'Open Sans', fontWeight:'lighter', fontStyle:'italic'}}>
                        {content}
                    </Typography>
                    <Link style={{textDecoration:'none'}} to={linkTo}>
                        <Typography  className='button' style={{textDecoration:'none',fontWeight:'lighter'}} >
                            Click here
                        </Typography>
                    </Link>
                </CardContent>
            </Card>
    );
};

export default NewComponent;
